import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppParams } from '../../../hooks/useAppParams';
import styles from './index.module.scss';

const tabs = [
  {
    label: 'Show all',
    path: '/transactions',
  },
  {
    label: 'GSX',
    path: '/transactions/currency/GSX',
  },
  {
    label: 'GSXI',
    path: '/transactions/currency/GSXI',
  },
  {
    label: 'GSXII',
    path: '/transactions/currency/GSXII',
  },
  {
    label: 'GSXX',
    path: '/transactions/currency/GSXX',
  },
  {
    label: 'MGT',
    path: '/transactions/currency/MGT',
  },
];

export const CurrencyTab = () => {
  const history = useHistory();
  const location = useLocation();
  const params = useAppParams();
  const [active, setActive] = useState<string | null>(null);

  const handleTab = (path: string) => () => {
    history.push(path);
  };

  useEffect(() => {
    if (params.code) {
      const activeObj = tabs.find((item) => item.label === params.code);
      setActive(activeObj?.label ?? null);
    } else if (
      location.pathname === tabs[0].path ||
      !location.pathname.includes('/accountId') ||
      !location.pathname.includes('/currency')
    ) {
      setActive(tabs[0].label);
    } else {
      setActive(null);
    }
  }, [location.pathname, setActive]);

  return (
    <div className={styles.tabs}>
      {tabs.map((tab) => (
        <button
          key={tab.path}
          className={classNames(styles.tabsButton, {
            [styles.tabsButtonActive]: active === tab.label,
          })}
          onClick={handleTab(tab.path)}
          aria-label={`Open ${tab.label} transactions`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
